import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import styles from "./SearchButton.module.scss";

export const HiddenResults = ({
    onClick,
    isDisabled,
}: {
    onClick: () => void;
    isDisabled?: boolean;
}) => (
    <div className={styles.hiddenResultsContainer}>
        <div>Adjust filters as needed.</div>
        <div>
            To see results, press Enter or click{" "}
            <Button
                label="Search"
                icon={IconCollection.magnify}
                variation="dark"
                onClick={onClick}
                disabled={isDisabled}
            />
        </div>
    </div>
);
